import React, { useEffect } from 'react';
import ContactUsCard from '../../Components/ContactUsCard/ContactUsCard';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgBlumenau from '../../assets/ContactLocation/Blumenau.png';
import imgSaoPaulo from '../../assets/ContactLocation/SaoPaulo.png';
import imgNavigators from '../../assets/ContactLocation/Navigators.png';
import imgRio from '../../assets/ContactLocation/Rio.png';
import imgCuritiba from '../../assets/ContactLocation/Curitiba.png';
import imgPorto from '../../assets/ContactLocation/Porto.png';
import imgSaoBernardo from '../../assets/ContactLocation/Rudge.png';
import imgAguaClara from '../../assets/ContactLocation/AguaClara.png';
import imgVarzeaGrande from '../../assets/ContactLocation/VarzeaGrande.png';
import imgStageImage from '../../assets/ContactLocation/StageImage.jpg';
import imgquality from '../../assets/bestquality.png'
import imgTag from '../../assets/Xcode.png'
import imgVan from '../../assets/van.png'
import imgWarehouse from '../../assets/Warehouse.png'
import FeaturesCardCarousel from '../../Components/FeaturesCardCarousal/FeatureCardCarousal';
import imgForm from '../../assets/ContactLocation/Form.jpg'
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import { Col, Row } from 'react-bootstrap';
import FeaturesCard from '../../Components/FeaturesCard/FeaturesCard';
import imgMhsCuritiba from '../../assets/ContactLocation/curitiba_pr.png';
import imgMhsSaoPaulo from '../../assets/ContactLocation/sao_paulo_sp.png';
import imgMhsSaoBernardo from '../../assets/ContactLocation/sao_bernardo_sp.png';
import imgMhsAguaClara from '../../assets/ContactLocation/AguaClara_satellite.png';

const ContactUs = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);
    const featuresData2 = [
        {
            title: "Contact Form",
            description: "",
            image: imgForm,
            cardclicklink: "/fale-conosco"
        },
        {
            title: "Mining Contact Form",
            description: "",
            image: imgForm,
            cardclicklink: "/campanha-mineracao-mg"
        },
        {
            title: "MHS Contact Form",
            description: "",
            image: imgForm,
            cardclicklink: "/campanha-mhs"
        },
        {
            title: "MHS Contact Form (PR)",
            description: "",
            image: imgForm,
            cardclicklink: "/campanha-mhs-pr"
        },
        {
            title: "MHS Contact Form (MS)",
            description: "",
            image: imgForm,
            cardclicklink: "/campanha-mhs-ms"
        },
        {
            title: "Offshore / Oil & Gas Contact Form",
            description: "",
            image: imgForm,
            cardclicklink: "/campanha-offshore"
        }
    ]

    const units = [
        {
            name: 'HANSA-FLEX Brazil Blumenau (Head Office)',
            location: 'HANSA-FLEX Brazil Ltd., Rodovia BR-470, 2461 - Itoupavazinha, Blumenau - SC, 89066-010, Brazil',
            telephone: '+55 47 3321 6300',
            mail: 'bbl@hansa-flex.com',
            image: imgBlumenau
        },
        {
            name: 'HANSA-FLEX Sao Paulo',
            location: 'HANSA-FLEX Sao Paulo, R. Eng. Antônio Pônzio Ippólito, 71 - Jaguará, São Paulo - SP, 05117-090, Brazil',
            telephone: '+55 11 2111 6300',
            mail: 'bsp@hansa-flex.com',
            image: imgSaoPaulo
        },
        {
            name: 'HANSA-FLEX Navegantes',
            location: 'HANSA-FLEX Navegantes, Avenida das Quaresmeiras, 2318 – Machados, Navegantes – SC, 88371-530, Brasil',
            telephone: '+55 47 3342 4404',
            mail: 'bit@hansa-flex.com',
            image: imgNavigators
        },
        {
            name: 'HANSA-FLEX Rio de Janeiro',
            location: 'HANSA-FLEX Rio de Janeiro, Av. Paris, 467 - Bonsucesso, Rio de Janeiro - RJ, 21041-020, Brazil',
            telephone: '+55 21 2688 1235',
            mail: 'bri@hansa-flex.com',
            image: imgRio
        },
        {
            name: 'HANSA-FLEX Curitiba',
            location: 'HANSA-FLEX Curitiba, Av. Juscelino Kubitschek De Oliveira - Ld, 7725 - Cidade Industrial de Curitiba, Curitiba - PR, 81350-160, Brazil',
            telephone: ' +55 41 3311 6350',
            mail: 'bca@hansa-flex.com',
            image: imgCuritiba
        },
        {
            name: 'HANSA-FLEX Porto Alegre',
            location: 'HANSA-FLEX Porto Alegre, Av. Brasil, 492 - Navegantes, Porto Alegre - RS, 90230-060, Brazil',
            telephone: ' +55 51 3191 6401',
            mail: 'bsa@hansa-flex.com',
            image: imgPorto
        },
        {
            name: 'HANSA-FLEX São Bernardo do Campo',
            location: 'HANSA-FLEX São Bernardo do Campo, Rua Três Mosqueteiros, 60 - Rudge Ramos, São Bernardo do Campo - SP, 09619-160, Brazil',
            telephone: '+55 11 2381 8331',
            mail: 'bsb@hansa-flex.com',
            image: imgSaoBernardo
        },
        {
            name: 'HANSA-FLEX Agua Clara',
            location: 'HANSA-FLEX Agua Clara, Rod 262, lot 17 79680-000 - Suburban, Água Clara - MS Brazil',
            telephone: '+55 67 4042 2871',
            mail: 'bac@hansa-flex.com',
            image: imgAguaClara
        },
        {
            name: 'HANSA-FLEX Várzea Grande (Cuiabá)',
            location: 'HANSA-FLEX Várzea Grande,Av. Gov. Julio D. Campos 4640,78141-000 Gloria Garden - Várzea Grande - MT, Brazil',
            telephone: '+55 65 4042 1132',
            mail: 'bcb@hansa-flex.com',
            image: imgVarzeaGrande
        },
        {
            name: 'MHS (SERVIÇO HIDRÁULICO MÓVEL) - CURITIBA (PR)',
            location: 'Av Juscelino K. de Oliveira, 7725 81350-160 Cidade Industrial - Curitiba - PR',
            telephone: '(41) 99725 0317',  
            telephone2: '(41) 99946 0036',
            mail: 'bca@hansa-flex.com',
            image: imgMhsCuritiba
        },
        // {
        //     name: 'MHS (SERVIÇO HIDRÁULICO MÓVEL) - SÃO PAULO (SP)',
        //     location: 'Rua Eng. Antônio Ponzio Ippólito, 71 05117-090 Vila Jaguara - São Paulo - SP',
        //     telephone: '(11) 98246 0913',
        //     image: imgMhsSaoPaulo
        // },
        {
            name: 'MHS (SERVIÇO HIDRÁULICO MÓVEL) – SÃO PAULO E SÃO BERNARDO DO CAMPO (SP)',
            location: 'Rua Tres Mosqueteiros, 60 09619-160 Rudge Ramos - São Bernardo do Campo - SP',
            telephone: '(11) 94806 2962',
            mail: 'bsb@hansa-flex.com',
            image: imgMhsSaoBernardo
        },
        {
            name: 'MHS (SERVIÇO HIDRÁULICO MÓVEL) - RONDONÓPOLIS (MT)',
            telephone: '(65) 99801 8411',
            mail: 'bcb@hansa-flex.com',
            image: imgBlumenau
        },
        {
            name: 'MHS (SERVIÇO HIDRÁULICO MÓVEL) - ÁGUA CLARA / TRÊS LAGOAS (MS)',
            location: 'Rod. BR 262, lote 17 79680-000 - Suburbana Água Clara - MS',
            telephone: '(67) 98216-1020',
            mail: 'bac@hansa-flex.com',
            image: imgMhsAguaClara
        }
    ];

    return (
        <div className="">
            <div>
                <CenterStage
                    imageSrc={imgStageImage}
                    title={"Get in Touch with HANSA-FLEX Brazil"}
                    paragraph={"We're here to assist you with all your hydraulic needs. Whether you have inquiries about our products, require technical support, or wish to explore partnership opportunities, our team is ready to help. Contact us today and experience the reliability and expertise that define HANSA-FLEX Brazil."}
                    buttonName={"Talk to us"}
                    buttonLink={"https://www.hansa-flex.com.br/fale-conosco"}
                />
            </div>
            <div className=''>
                <ContactUsCard units={units} />
            </div>
            <br /><br />
            <SectionHeader title="Contact Forms" />

            {/* <FeaturesCardCarousel
                featuresData={featuresData2}
                layout="carousel"
            /> */}

            <Row className='d-flex justify-content-center'>
                <Col>
                    <FeaturesCard title="Contact Form" description="" image={imgForm} cardclicklink="/fale-conosco" />
                </Col>
            </Row>
            <br /><br />
            <br /><br />
        </div>
    );
};

export default ContactUs;
